import {
  getData,
  deleteData
} from './request'

// 获取共享列表
export function getReceived({offset,count,type}, cb) {
  let url = type == "received" ? `/api/v3/linkslist?offset=${offset}&count=${count}&type=${type}&orderby=mtime&order=DESC` : `/api/v5/links/mine?offset=${offset}&count=${count}&orderby=ctime&order=DESC`
  return getData(url, {}, cb)
}

// 删除分享列表文件
export function deleteShare(paload, cb) {
  return deleteData(`/api/v3/linksinfo/batch/destory`, paload, {}, cb)
}


// WEBPACK FOOTER //
// ./src/store/service/received.js